import { HelpCircle } from 'lucide-react'
import { Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip'

/**
 * Small "?" icon that, on hover/focus, surfaces a one-liner explainer
 * about the field it sits next to. Use it inside `<Label>` rows in any
 * settings form to keep field copy short while still letting users
 * discover what the field actually does.
 *
 * Example:
 *   <div className="flex items-center gap-1">
 *     <Label htmlFor="msg-tone">Message Tone</Label>
 *     <FieldHint label="What is message tone?">
 *       Controls how formal or casual the AI's writing sounds.
 *     </FieldHint>
 *   </div>
 */
export function FieldHint({
  label = 'What is this?',
  children,
}: {
  readonly label?: string
  readonly children: React.ReactNode
}) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label={label}
          className="relative inline-flex shrink-0 items-center justify-center rounded-full text-muted-foreground transition-colors after:absolute after:-inset-2.5 after:content-[''] hover:text-foreground focus:outline-none focus:text-foreground focus-visible:ring-2 focus-visible:ring-ring"
        >
          <HelpCircle className="h-3.5 w-3.5" />
        </button>
      </TooltipTrigger>
      <TooltipContent side="top">{children}</TooltipContent>
    </Tooltip>
  )
}
